import React, { useRef, useEffect } from 'react';
import { motion, useInView, animate } from 'framer-motion';
import { FaUsers, FaChartLine, FaTrophy, FaHeadset } from 'react-icons/fa';

const stats = [
  { value: 500, suffix: '+', label: 'Happy Clients', icon: FaUsers },
  { value: 98, suffix: '%', label: 'Success Rate', icon: FaChartLine },
  { value: 150, suffix: '%', label: 'Avg ROI Increase', icon: FaTrophy },
  { value: 24, suffix: '/7', label: 'Support', icon: FaHeadset },
];

function AnimatedCounter({ to, suffix }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  useEffect(() => {
    if (isInView) {
      const controls = animate(0, to, {
        duration: 2.5,
        ease: "easeOut",
        onUpdate(value) {
          if (ref.current) {
            ref.current.textContent = Math.round(value) + suffix;
          }
        }
      });
      return () => controls.stop();
    }
  }, [isInView, to, suffix]);

  return <span ref={ref}>0{suffix}</span>;
}

export default function Stats() {
  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8">
        {stats.map((s, i) => (
          <motion.div key={s.label}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.05 }}
            whileHover={{ y: -5 }} className="text-center group">
            <div className="relative inline-block mb-4">
              <motion.div whileHover={{ rotate: 360 }} transition={{ duration: 0.6 }}
                className="w-20 h-20 mx-auto rounded-2xl bg-gradient-to-br from-cyan-500/20 to-orange-500/20 border border-cyan-500/30 flex items-center justify-center group-hover:border-cyan-400/60 transition-all backdrop-blur-sm">
                <s.icon className="text-3xl text-cyan-400" />
              </motion.div>
            </div>
            <h3 className="text-4xl lg:text-5xl font-black bg-gradient-to-r from-gray-900 to-gray-600 dark:from-white dark:to-gray-400 bg-clip-text text-transparent mb-2">
              <AnimatedCounter to={s.value} suffix={s.suffix} />
            </h3>
            <p className="text-gray-500 font-medium text-sm tracking-wide uppercase">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
